import { render, staticRenderFns } from "./RuteEdit.vue?vue&type=template&id=40512b4f&scoped=true"
import script from "./RuteEdit.vue?vue&type=script&lang=js"
export * from "./RuteEdit.vue?vue&type=script&lang=js"
import style0 from "./RuteEdit.vue?vue&type=style&index=0&id=40512b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40512b4f",
  null
  
)

export default component.exports